// import React from 'react';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import NoDataPlaceholder from '../NoDataPlaceholder';

// const TableView = ({ body,actions  }) => {
//   // Extract the keys from the first object in the body array to create headings
//   const headings = body.length > 0 && Object.keys(body[0]);

//   return (<>{body.length > 0 ?
//     <TableContainer component={Paper}>
//       <Table size='small'>
//         <TableHead>
//           <TableRow>
//           <TableCell >SR.</TableCell>
//           {headings.map((heading, index) => heading !='ID' &&(<TableCell key={index}>{heading}</TableCell>))}
//           <TableCell align='right'>Actions</TableCell> {/* Extra column for actions */}
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {body.map((row, rowIndex) => (
//             <TableRow key={rowIndex}>
//               <TableCell>{rowIndex +1}</TableCell>
//               {headings.map((heading, headingIndex) => heading !='ID' &&(
//                 <TableCell key={headingIndex}>{row[heading]}</TableCell>
//               ))}
//               <TableCell align='right'>
//                 {/* Render your action components or buttons here */}
//                 {actions && actions(row)}
//               </TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>:<NoDataPlaceholder/>}
//   </>
//   )
// };

// export default TableView;
import { useEffect, useState } from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import NoDataPlaceholder from '../NoDataPlaceholder'; // Your placeholder component for no data

const TableView = ({ body, actions }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  // Extract the keys from the first object in the body array to create headings
  const headings = body.length > 0 ? Object.keys(body[0]) : [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(()=>{
    setPage(0)
    setRowsPerPage(50)
  },[body])

  return (
    <>
      {body.length > 0 ? (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>SR.</TableCell>
                {headings.map((heading, index) => heading !== 'ID' && <TableCell key={index}>{heading}</TableCell>)}
                {actions&& <TableCell align="right">Actions</TableCell>} {/* Extra column for actions */}
              </TableRow>
            </TableHead>
            <TableBody>
              {body.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  <TableCell>{page * rowsPerPage + rowIndex + 1}</TableCell>
                  {headings.map(
                    (heading, headingIndex) =>
                      heading !== 'ID' && <TableCell key={headingIndex}>{row[heading]}</TableCell>
                  )}
                  {actions &&<TableCell align="right">{actions && actions(row)}</TableCell>}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[50, 100, 150]}
            component="div"
            count={body.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      ) : (
        <NoDataPlaceholder />
      )}
    </>
  );
};

export default TableView;
